import { z } from "zod";

export const notificationDeliveryFrequencySchema = z.enum([
	"off",
	"immediately",
	"daily",
	"weekly",
]);

export const taskAssignmentNotificationFrequencySchema = z.enum([
	"off",
	"immediately",
]);

export const notificationDeliveryChannelSchema = z.enum(["email"]);

export const updateUserNotificationPreferencesSchema = z
	.object({
		channel: notificationDeliveryChannelSchema.default("email"),
		commentNotifications: notificationDeliveryFrequencySchema,
		taskAssignmentNotifications: taskAssignmentNotificationFrequencySchema,
	})
	.strict();

export const upsertProjectNotificationPreferenceSchema = z
	.object({
		projectId: z.uuid(),
		channel: notificationDeliveryChannelSchema.default("email"),
		commentNotifications: notificationDeliveryFrequencySchema.nullable(),
		taskAssignmentNotifications:
			taskAssignmentNotificationFrequencySchema.nullable(),
	})
	.strict();

export const clearProjectNotificationPreferenceSchema = z
	.object({
		projectId: z.uuid(),
		channel: notificationDeliveryChannelSchema.default("email"),
	})
	.strict();

export type NotificationDeliveryFrequency = z.infer<
	typeof notificationDeliveryFrequencySchema
>;
export type TaskAssignmentNotificationFrequency = z.infer<
	typeof taskAssignmentNotificationFrequencySchema
>;
export type NotificationDeliveryChannel = z.infer<
	typeof notificationDeliveryChannelSchema
>;
export type UpdateUserNotificationPreferencesInput = z.infer<
	typeof updateUserNotificationPreferencesSchema
>;
export type UpsertProjectNotificationPreferenceInput = z.infer<
	typeof upsertProjectNotificationPreferenceSchema
>;
